"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _StaticPanel = require("./styled/StaticPanel");

var _core = require("@emotion/core");

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Panel = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, _ref2) {
  var className = _ref.className,
      isOpen = _ref.isOpen,
      children = _ref.children,
      togglePanel = _ref.togglePanel,
      onClickOutside = _ref.onClickOutside,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'right' : _ref$position,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100%' : _ref$height,
      restProps = _objectWithoutProperties(_ref, ["className", "isOpen", "children", "togglePanel", "onClickOutside", "position", "width", "height"]);

  var containerRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var listener = onClickOutside ? function (event) {
      if (event.target instanceof Node && containerRef.current && !containerRef.current.contains(event.target)) {
        onClickOutside(event, togglePanel);
      }
    } : null;

    if (isOpen && listener) {
      document.addEventListener('mousedown', listener);
    }

    return function () {
      if (listener) {
        document.removeEventListener('mousedown', listener);
      }
    };
  }, [onClickOutside, isOpen]);
  return (0, _core.jsx)(_StaticPanel.StaticContainer, _extends({}, restProps, {
    className: className,
    isOpen: isOpen,
    position: position,
    onClick: function onClick(ev) {
      return ev.stopPropagation();
    },
    width: width,
    height: height,
    ref: function ref(element) {
      containerRef.current = element;

      if (_ref2) {
        _ref2.current = element;
      }
    }
  }), isOpen && children);
});
Panel.displayName = 'Panel';
var _default = Panel;
exports["default"] = _default;